import axiosClient from "./axiosClient";

export const appendValues = (consumerRequestData) =>
  axiosClient.post(`/consumer/request`, consumerRequestData);
